import React from 'react';
import { render } from 'react-dom';
import { SocialShare } from '@sky-uk/sky-social-share';

export const initSocialShare = () => {
  document.querySelectorAll<HTMLElement>('.j-social-share:not([data-initialized])').forEach(($root) => {
    const htmlProps = JSON.parse($root.dataset.json || '{}');
    render(<SocialShare {...htmlProps} />, $root);
    $root.setAttribute('data-initialized', 'true');
  });
};
